import { buildSerializer, SerializeMap } from "lib/serializerUtils";

// Embedded form (omits `permissions` to avoid a per-row permission query when
// serializing a list of sales).
export const embeddedSaleAttributesSerializeMap = {
  id: "id",
  livestockSaleId: "livestock_sale_id",
  saleStatusId: "sale_status_id",
  managerIds: "manager_ids",
  assigneeIds: "assignee_ids",
  created: "created",
  lastModified: "last_modified",
};

const saleAttributesSerializeMap: SerializeMap<SaleAttributes> = {
  ...embeddedSaleAttributesSerializeMap,
  permissions: "permissions",
};

export const serializeSaleAttributes = buildSerializer(
  saleAttributesSerializeMap,
  "saleAttributes",
);
